export default "__VITE_ASSET__5e555ac7__"